import React, { Fragment } from 'react';

function getDesign(messageListPwdResetCompletion) {

  return (
    <Fragment>
      <div className="contentInner">
        <div className="ds-heading ds-heading--sm">
          <h2 className="ds-heading__title">{messageListPwdResetCompletion.M004_notices}</h2>
        </div>
        <ul className="ds-listText ds-listText--md">
          <li className="ds-listText__item">{messageListPwdResetCompletion.M004_notice001}</li>
        </ul>
      </div>
    </Fragment>
  );
}

export { getDesign }